import { render, staticRenderFns } from "./ux-chart.vue?vue&type=template&id=f287211c&"
import script from "./ux-chart.vue?vue&type=script&lang=js&"
export * from "./ux-chart.vue?vue&type=script&lang=js&"
import style0 from "./ux-chart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports